<template>
  <div class="section">
    <div class="bar">
      <van-notice-bar :scrollable="false" class="bg-title" color="#fff">
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false"
        >
          <van-swipe-item>小*爸爸邀请了2人，获得2千学贝</van-swipe-item>
          <van-swipe-item>一*妈妈邀请了1人，获得1千学贝</van-swipe-item>
          <van-swipe-item>139*4875邀请了3人，获得3千学贝</van-swipe-item>
          <van-swipe-item>陈*妈妈邀请了5人，获得5千学贝</van-swipe-item>
          <van-swipe-item>185*2923邀请了10人，获得1万学贝</van-swipe-item>
          <van-swipe-item>150*8028邀请了8人，获得8千学贝</van-swipe-item>
          <van-swipe-item>林*妈妈邀请了2人，获得2千学贝</van-swipe-item>
          <van-swipe-item>王*惠妈妈邀请了4人，获得4千学贝</van-swipe-item>
          <van-swipe-item>娜*奶奶邀请了1人，获得1千学贝</van-swipe-item>
          <van-swipe-item>156*2375邀请了2人，获得2千学贝</van-swipe-item>
        </van-swipe>
      </van-notice-bar>
    </div>
    <p class="gold-text">1000</p>
    <p class="tip">邀请码：{{ inviteCode }}</p>
    <div class="btn-copy" @click="copy">复制</div>
    <div
      class="input-code"
      :class="{ inputEnable: canFillInCode === 1 }"
      @click="inputCode"
    >
      输入邀请码
    </div>
  </div>
</template>

<script>
import { copy2Clipboard } from "@/utils/hybird";

export default {
  props: ["inviteCode", "canFillInCode"],
  data() {
    return {
      studentNames: [
        "小*爸爸邀请了2人，获得2千学贝",
        "一*妈妈邀请了1人，获得1千学贝",
        "139*4875邀请了3人，获得3千学贝",
        "陈*妈妈邀请了5人，获得5千学贝",
        "185*2923邀请了10人，获得1万学贝",
        "150*8028邀请了8人，获得8千学贝",
        "林*妈妈邀请了2人，获得2千学贝",
        "王*惠妈妈邀请了4人，获得4千学贝",
        "娜*奶奶邀请了1人，获得1千学贝",
        "156*2375邀请了2人，获得2千学贝",
      ],
      randomNameList: [],
      animate: false,
    };
  },
  mounted() {
    // this.randomNameList = this.getArrayItems(this.studentNames, 10);
    // setInterval(this.showMarquee, 2000);
  },
  methods: {
    showMarquee: function () {
      this.animate = true;
      setTimeout(() => {
        this.randomNameList.push(this.randomNameList[0]);
        this.randomNameList.shift();
        this.animate = false;
      }, 500);
    },
    getArrayItems(arr, num) {
      //新建一个数组,将传入的数组复制过来,用于运算,而不要直接操作传入的数组;
      var temp_array = new Array();
      for (var index in arr) {
        temp_array.push(arr[index]);
      }
      //取出的数值项,保存在此数组
      var return_array = new Array();
      for (var i = 0; i < num; i++) {
        //判断如果数组还有可以取出的元素,以防下标越界
        if (temp_array.length > 0) {
          //在数组中产生一个随机索引
          var arrIndex = Math.floor(Math.random() * temp_array.length);
          //将此随机索引的对应的数组元素值复制出来
          return_array[i] = temp_array[arrIndex];
          //然后删掉此索引的数组元素,这时候temp_array变为新的数组
          temp_array.splice(arrIndex, 1);
        } else {
          //数组中数据项取完后,退出循环,比如数组本来只有10项,但要求取出20项.
          break;
        }
      }
      return return_array;
    },
    copy() {
      copy2Clipboard(this.inviteCode);
      this.$emit("handleCopy");
    },
    inputCode() {
      if (this.canFillInCode === 1) {
        this.$emit("handleInputCode");
      } else {
        this.$toast("仅限未被邀请的新用户");
      }
    },
    exit() {
      location.href = "hybird://method/exit";
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  position:absolute;
  width: 7.51rem;
  height: 8.4rem;
  background: url("../../../../assets/images/parent_active/invite/bg_invite_code.png")
    0 0 / cover no-repeat;
  .bar {
    width: 100%;
    text-align: center;
    margin-top: 1rem;
    .back {
      width: 0.64rem;
      height: 0.62rem;
      position: absolute;
      left: 0.62rem;
    }
    .bg-title {
      background: url("../../../../assets/images/parent_active/invite/bg_marquee.png")
        0 0 / cover no-repeat;
      margin-left: 1.1rem;
      margin-right: 1.1rem;
      // margin-top: 1rem;
      text-align: center;
      background-size: 4.4rem 0.5rem;
      height: 00.5rem;
      display: flex;
      overflow: hidden;
      align-self: center;
      .marquee_list {
        margin: auto;
        top: 0px;
        height: 0.5rem;
      }
      .marquee_top {
        transition: all 0.5s;
        margin-top: -0.5rem;
      }
      .title {
        font-size: 0.22rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        line-height: 0.56rem;
      }
    }
  }
  .gold-text {
    margin: auto;
    width: 2.2rem;
    height: 0.58rem;
    font-size: 0.78rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: #8a200c;
    line-height: 1.83rem;
    margin-top: 2.8rem;
    &:after {
      content: "";
      position: absolute;
      margin-top: 00.84rem;
      width: 0.4rem;
      height: 0.4rem;
      background: url("../../../../assets/images/parent_active/invite/ic_gold.png")
        0 0 / cover no-repeat;
    }
  }
  .tip {
    font-size: 0.28rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #8a200c;
    line-height: 0.57rem;
    margin-top: 0.9rem;
    margin-left: 1.94rem;
  }
  .btn-copy {
    $h: 0.42rem;
    width: 0.98rem;
    height: $h;
    border-radius: 0.21rem;
    background-color: #e2aa5b;
    font-size: 0.24rem;
    color: #8a200c;
    line-height: $h;
    text-align: center;
    margin-right: 1.6rem;
    margin-left: auto;
    margin-top: -0.5rem;
  }
  .input-code {
    $h: 0.34rem;
    width: 2.6rem;
    height: $h;
    border-radius: 0.15rem;
    background: #ebbb79;
    font-size: 0.22rem;
    color: #f6d2a0;
    line-height: $h;
    text-align: center;
    margin-right: auto;
    margin-left: auto;
    margin-top: 0.2rem;
  }
  .inputEnable {
    color: #8a200c;
  }
  .notice-swipe {
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
}
</style>